import { render } from "./MCRadiogroup.vue?vue&type=template&id=22f6b029&ts=true"
import script from "./MCRadiogroup.vue?vue&type=script&lang=ts"
export * from "./MCRadiogroup.vue?vue&type=script&lang=ts"

import "./MCRadiogroup.vue?vue&type=style&index=0&id=22f6b029&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__